import { useMemo, useCallback, useEffect, useState } from 'react';
import { Select } from 'foundations-components/transitional/components/Select';
import { FormLabel } from 'foundations-components/transitional/components/FormLabel';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getUEDropdownOptions, getUnifiedEvent, getUEDropdownGroup, loadGroupEventProperties } from './utils';
import updateReport from './updateReport';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const UnifiedEventDropdown = ({
  report,
  onChange
}) => {
  const event = useMemo(() => getUnifiedEvent(report), [report]);
  const group = useMemo(() => getUEDropdownGroup(event), [event]);
  const [eventProperties, setEventProperties] = useState({});
  const options = useMemo(() => group ? getUEDropdownOptions(group) : [], [group]);
  useEffect(() => {
    if (group) {
      loadGroupEventProperties(group).then(setEventProperties).catch(console.error);
    }
  }, [group]);
  const handleChange = useCallback(({
    target: {
      value
    }
  }) => onChange(updateReport(report, value, eventProperties)), [report, onChange, eventProperties]);
  if (!group) {
    return null;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(FormLabel, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "report-customization-components.customization-components.unified-event-dropdown.label"
      })
    }), /*#__PURE__*/_jsx(Select, {
      value: event,
      options: options,
      onChange: handleChange
    })]
  });
};
export default UnifiedEventDropdown;